<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.RecruitmentImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{$t("menu.Team") }}</div>
            </template>

            <template #ContentEr>
              <!-- <div class="inlineer"> -->
              <li>
                <router-link to="/LaboratoryCenter"><div>{{$t("menu.LaboratoryCenter") }} </div></router-link>
              </li>
              <!-- </div> -->
            </template>

            <template #ContentSan>
              <!-- <div class="inlineer"> -->
              <li>
                <router-link to="/Recruitment"
                  ><div style="color: #1d2088">{{$t("menu.Recruitment") }}</div></router-link
                >
              </li>
              <!-- </div> -->
            </template>
          </Content>
        </el-col>
        <el-col :span="17">
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{$t("menu.Recruitment") }}</h3>
          </div>
          <div class="fff">
            
            <el-table :data="NewList" style="width: 100%" >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form
                  
                    label-position="left"
                    inline
                    class="demo-table-expand"
                  >
                    <el-row>
                      <el-col :span="10">
                        <el-form-item :label="$t('menu.WorkingArea') ">
                          <!-- <span>{{ props.row.place }}</span> -->
                          <span>{{ props.row.place }} </span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item  :label="$t('menu.recruitingNumbers') ">
                          <span>{{ props.row.number }} </span>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="10">
                        <el-form-item :label="$t('menu.ExperienceRequirements') ">
                          <!-- <span>{{ props.row.id }}</span> -->
                          <span>{{ props.row.experience }} </span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item :label="$t('menu.educationalRequirements') ">
                          <!-- <span>{{ props.row.shopId }}</span> -->
                          <span>{{ props.row.education }} </span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item :label="$t('menu.responsibilities') ">
                      <!-- <span></span> -->
                      <ul class="ul">
                        <pre>   <li v-html="props.row.jobDuty">
                    
                        </li></pre>
                        <!-- <li>2、具有良好的在校表现和社会实践经历；</li>
                        <li>3、有业务销售或第三方实验室业务经验优先；</li>
                        <li>4、沟通能力强，团队协作精神佳，服从管理安排；</li>
                        <li>5、有一定业务客户者优先考虑；</li> -->
                      </ul>
                    </el-form-item>
                    <el-form-item :label="$t('menu.jobRequirements')">
              
                      <ul class="ul">
                        <pre>   <li v-html="props.row.jobRequirements">

                        </li></pre>
                      </ul>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column  header-align="left" :label="$t('menu.jobtitle')" prop="jobTitle"> </el-table-column>
              <el-table-column  header-align="left" :label="$t('menu.reDate')" prop="releaseDate"> </el-table-column>

              <el-table-column  header-align="left" :label="$t('menu.deliver')">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    round
                    @click="handleEdit(scope.$index, scope.row)"
                    >{{$t("menu.deliver") }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="this.total"
              :current-page="queryInfo.page"
              :page-size="queryInfo.size"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 对话框 -->

    <el-dialog :visible.sync="dialogVisible">
      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{$t('menu.deliveryOfInformation')}}</h3>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <!--    :rules="rules" -->
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('menu.name')" prop="name">
              <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('menu.tel')" prop="tel">
              <el-input v-model="ruleForm.tel" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
          
          </el-col> -->
          <el-col :span="12"> </el-col>
        </el-row>

        <!-- -->
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('menu.mailbox')" prop="mailbox">
              <el-input v-model="ruleForm.mailbox"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('menu.entryDate')"  prop="entryDate">
              <el-date-picker
                type="date"
              
                v-model="ruleForm.entryDate"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="jobTitle" label="职位">
              <el-input
                type="text"
                placeholder="职位"
                v-model="ruleForm.jobTitle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('menu.introduce')" prop="introduce">
              <el-input v-model="ruleForm.introduce" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <p class="red">
           {{$t('menu.offer')}}
          </p>
        </el-col>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="" prop="archive">
              <!-- <el-input type="file"></el-input> -->
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=" .docx, .pdf"
                action="https://lab.sealtech.com/api/Team/UploadFile"
                :on-preview="handlePreview"
                :on-success="success"

                :on-remove="handleRemove"
 
                :auto-upload="false" 
                :on-change="submitUpload"
                v-model="ruleForm.archive">
                <el-button slot="trigger" size="small" type=""
                  >        {{$t('menu.SlectFile')}}</el-button >
                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-form-item>
            <el-button size="mini" round @click="BtnSend()">        {{$t('menu.send')}}</el-button>

            <el-button size="mini" @click="resetForm()" round>        {{$t('menu.reset')}}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

  
<style lang="less" scoped>
.ul li {
  list-style: none;
  color: #999999;
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 0px;
}
/deep/ .el-form {
  padding: 0px 20px;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
/deep/ .el-dialog {
  width: 556px;
  // height: 690px;
}
.el-button--small {
  background: #eeeeee;
}
// /deep/ .el-form-item {
//   margin: 0px;
// }
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.red {
  // margin-top: 20px;
  font-size: 12px;
  color: #ff0000;
}
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}
.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  padding-top: 0px;
  margin-bottom: 20px;
}

a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
/deep/ .demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  /* width: 100%; */
}



/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1d2088;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #979df2;
}
.el-pagination {
  margin-top: 20px;
}
/deep/ .el-table th.el-table__cell>.cell{
padding: 0px;
margin: 0px;
}
</style>

<script>
export default {
  name: "LaboratoryCenter",

  data() {
    //合法的邮箱
    var checkEmail = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的邮箱*"));
    };
    //  验证手机号的规则
    var checkPhone = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regPhone =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regPhone.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      number: "4-2",
      dialogVisible: false,

      queryInfo: {
        //  query:"",
        //当前的页数
        page: 1,
        size: 5, //多少条数据\
        languageType: this.title,
      },
      total: 0,
      NewList: [],

      ruleForm: {
        name: "",
        tel: "",
        mailbox: "", //邮箱
        jobTitle: "", //职位
        entryDate: "", // 日期
        jobTitle: "", // 投递的职位
        introduce: "", //自我介绍
        archive: "", //文件url地址
      },
      unlpadurl:"",
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          // {
          //   min: 2,
          //   max: 10,
          //   message: "用户名的长度在2~10个字符之间",
          //   triggerğ: "blur",
          // },
        ],
        tel: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        mailbox: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
      
        entryDate: [{ required: true, message: "请输入日期", trigger: "blur" }],

        introduce: [
          { required: true, message: "请输入自我介绍", trigger: "blur" },
        ],
        //
        archive: [{ required: true, message: "请提交文件,只能上传pdf，docx格式文件", trigger: "blur" }],
      },
    };
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelect();
  },
//   beforeUpdate:function(){
// this.beforeUpload();
//   },
  methods: {

/////////////////////////////////图片上传//////////////////////////////////////////



// 上传之前判断
    // beforeUpload(file) {
    //   // return true;
    //   console.log(file);
    //    console.log(11);
    //   // this.archive = file;

    //   const extension = file.name.split(".")[1] === "pdf";
    //   const extension2 = file.name.split(".")[1] === "docx";
    //   //  const isLt2M = file.size / 1024 / 1024 < 5
    //   if (!extension && !extension2) {
    //     this.$message.error("上传模板只能是 pdf、docx格式!");
    //     return ;
    //   }
    //   //  if (!isLt2M) {
    //   //   this.$message.warning('上传模板大小不能超过 5MB!')
    //   //   return
    //   //  }
    //   this.fileName = file.name;
    //   return true; // 返回false不会自动上传
    // },

//  上传时移除的方法
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
// 添加文件
    handlePreview(file) { 
      console.log(file);
    },
    // 上传服务器
   submitUpload() {

      this.$refs.upload.submit();
    },
    //图片上传成功
    success(response, file, fileList) {
      if(response.code === 200){
         this.unlpadurl=response.data;
         this.ruleForm.archive="https://lab.sealtech.com"+response.data;
          //  this.$message.success( response.msg)
      }else{
              this.$message.error( response.msg)
                  //  this.unlpadurl=""
      }
      // console.log(response);
    },
    //     //图片上传错误
    // error(err, file, fileList){
    //  console.log(err);

    // },



/////////////////////////////////图片上传//////////////////////////////////////////





    // 查询数据
    async getSelect() {
      const { data: resER } = await this.$http.get("/Team/GetRecruitmentInfo", {
        params: this.queryInfo,
      });
      if (resER.code !== 200) return console.log("数据请求失败! ");
      this.NewList = resER.data;
      this.total = resER.total;
      console.log(this.NewList);
    },
    // 页码改变事件
    handleCurrentChange(val) {
      this.queryInfo.page = val;
      this.getSelect();
    },
    handleEdit(index, row) {
      console.log( row);

//职位投递
this.jobTitle=row.jobTitle

      this.dialogVisible = true;
    },
    // 重置按钮
    resetForm() {
      this.$refs.ruleForm.resetFields();
      // this.ruleForm.archive="";
    },


    // 发送按钮
    BtnSend() {
      

      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return;
        // 可以发起添加网络的请求
        const { data: res } = await this.$http.post(
          "/Team/AddResume",
          ///Team/AddResume
          this.ruleForm,
          { header: { "content-type": "application/json-patch+json" } }
          //  header:{"content-type": "application/json-patch+json"},
        );

        console.log(this.ruleForm);

        if (res.code === 200) {
                this.dialogVisible = false;
          this.$refs.ruleForm.resetFields();
            this.getSelect();
          this.$message.success("提交建议反馈成功! ");
        } else {
          this.$message.error("提交建议反馈失败! ");
        }
      });
    },
  },
};
</script>